import React, { forwardRef } from "react";

import Button from "@mui/material/Button";
import Alert, { AlertColor } from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { SnackbarContent, CustomContentProps, closeSnackbar } from "notistack";

export interface SnackBarTransactionProps extends CustomContentProps {
  undoFunction: () => Promise<void>;
  severity?: AlertColor;
}

// eslint-disable-next-line react/display-name
const SnackBarTransaction = forwardRef<
  HTMLDivElement,
  SnackBarTransactionProps
>((props, ref) => {
  const { id, message, undoFunction, severity, ...other } = props;

  return (
    <SnackbarContent ref={ref} role="alert" {...other}>
      <Alert
        severity={severity}
        action={
          <>
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                undoFunction();
                closeSnackbar(id);
              }}
            >
              UNDO
            </Button>
            <IconButton
              color="inherit"
              size="small"
              onClick={() => {
                closeSnackbar(id);
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
        onClose={() => {
          closeSnackbar(id);
        }}
        sx={{ width: "100%" }}
        variant="filled"
      >
        {message}
      </Alert>
    </SnackbarContent>
  );
});

export default SnackBarTransaction;
